import { FC } from 'react';
import { CreateCustomDestinationContent } from './createCustomDestinationContent';

export const CreateCustomDestination: FC = () => {
  return <CreateCustomDestinationContent />;
};
